import { useCallback, useEffect, useRef, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { heroSlides } from "../../data/content";

const AUTOPLAY_MS = 6000;

export default function Hero() {
  const [index, setIndex] = useState(0);
  const timerRef = useRef(null);

  const goTo = useCallback((next) => {
    setIndex(((next % heroSlides.length) + heroSlides.length) % heroSlides.length);
  }, []);

  useEffect(() => {
    timerRef.current = setInterval(() => goTo(index + 1), AUTOPLAY_MS);
    return () => clearInterval(timerRef.current);
  }, [index, goTo]);

  return (
    <section id="accueil" className="relative h-[92vh] min-h-[600px] w-full overflow-hidden bg-ink">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.image}
          aria-hidden={i !== index}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            i === index ? "opacity-100" : "pointer-events-none opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt=""
            className="h-full w-full object-cover"
            loading={i === 0 ? "eager" : "lazy"}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80" />
        </div>
      ))}

      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
        {heroSlides.map((slide, i) => (
          <div
            key={slide.title}
            className={`max-w-3xl transition-all duration-700 ${
              i === index ? "translate-y-0 opacity-100" : "pointer-events-none absolute translate-y-4 opacity-0"
            }`}
          >
            <span className="eyebrow mb-4">{slide.eyebrow}</span>
            <h1 className="text-balance font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl lg:text-6xl">
              {slide.title}
            </h1>
            <p className="mx-auto mt-6 max-w-xl text-base text-stone-200 sm:text-lg">{slide.text}</p>
          </div>
        ))}

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a href="#reservation" className="btn-primary">
            Réserver une prestation
          </a>
          <a href="#rejoignez-nous" className="btn-outline">
            Rejoindre la troupe
          </a>
        </div>
      </div>

      <button
        type="button"
        onClick={() => goTo(index - 1)}
        aria-label="Diapositive précédente"
        className="absolute left-3 top-1/2 z-10 hidden h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-white/20 text-white transition-colors hover:border-gold-500 hover:text-gold-500 sm:flex sm:left-6"
      >
        <FaChevronLeft />
      </button>
      <button
        type="button"
        onClick={() => goTo(index + 1)}
        aria-label="Diapositive suivante"
        className="absolute right-3 top-1/2 z-10 hidden h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-white/20 text-white transition-colors hover:border-gold-500 hover:text-gold-500 sm:flex sm:right-6"
      >
        <FaChevronRight />
      </button>

      <div className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 gap-2">
        {heroSlides.map((slide, i) => (
          <button
            key={slide.image}
            type="button"
            onClick={() => goTo(i)}
            aria-label={`Aller à la diapositive ${i + 1}`}
            aria-current={i === index}
            className={`h-2 rounded-full transition-all duration-300 ${
              i === index ? "w-8 bg-gold-500" : "w-2 bg-white/40 hover:bg-white/70"
            }`}
          />
        ))}
      </div>
    </section>
  );
}
